/** 
 * 新官网地址
*/
export const EDU_WPS_CN_URL = 'https://edu.wps.cn/';

/**
 * WPS Comate 教育版官网地址（带渠道参数）
 */
export const COMATE_EDU_URL =
  'https://edu.wps.cn/comate?chn=wps365edu_pc_office';
